export default function LocationHistory() {
  return (
    <div style={{ padding: '1rem' }}>
      <h1>Location History</h1>
    </div>
  );
}